export default __webpack_public_path__ + "static/media/looptv-logo.a2d4508b.png";